module.exports = __webpack_public_path__ + "static/media/resources_icon.9ccab516.svg";